module.exports = __webpack_public_path__ + "static/img/global-site-building@w.7f9a299.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos/global-site-building@w.png
// module id = 15lG
// module chunks = 0